import { type ReactNode } from "react";

import { cn } from "~/lib/utils";

type MacroChipProps = {
  /** Numeric value; `null` renders a placeholder dash. */
  value: number | null;
  /** Unit suffix, e.g. "g". Empty for energy/kcal. */
  unit?: string;
  /** Translatable macro name, e.g. "Protein". */
  label: ReactNode;
  className?: string;
};

/** A single "macro at a glance" chip: big value on top, label underneath. */
export const MacroChip = ({
  value,
  unit,
  label,
  className
}: MacroChipProps) => {
  let display = "–";
  if (value !== null) {
    display = unit ? `${value} ${unit}` : `${value}`;
  }

  return (
    <div
      className={cn(
        "flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-2xl bg-kiosk-background-secondary px-1.5 py-3.5",
        className
      )}
    >
      <p className="text-2xl font-bold leading-none text-kiosk-text-primary">
        {display}
      </p>
      <p className="text-sm font-medium text-kiosk-text-secondary">{label}</p>
    </div>
  );
};
